import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthService } from '@mangosoft/mango-login';
import { Observable } from 'rxjs';
@Injectable({
	providedIn: 'root',
})
export class ApiInterceptor implements HttpInterceptor {
	constructor(private auth: AuthService) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const language = localStorage.getItem('mg-language') || 'en';
		let req = request;
		if (
			!req.url.includes('X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-') &&
			!req.url.includes('geo.wpforms.com/v3/geolocate/json')
		) {
			req = request.clone({
				setHeaders: {
					'Content-Type': 'application/json',
					// 'language-mg': `${language}`,
					Authorization: `${this.auth.getToken()}`,
				},
			});
		}
		return next.handle(req);
	}
}
